module.exports = __webpack_public_path__ + "img/bg_function06_2_d.73d16b87.png";